module.exports = __webpack_public_path__ + "img/VIDEO08.be583152.png";